// extracted by mini-css-extract-plugin
export default {"download__button":"DownloadButton_download__button__PfqL6","label":"DownloadButton_label__Deu8X"};